import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import userService from '../../services/userService';
import ChangePasswordModal from '../../components/ChangePasswordModal';

const Profile: React.FC = () => {
  const { user } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  if (!user) {
    return (
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <h1 className="m-0">Meu Perfil</h1>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="alert alert-warning">
              <i className="fas fa-exclamation-triangle"></i> Usuário não autenticado
            </div>
          </div>
        </section>
      </div>
    );
  }

  const handleOpenPasswordModal = () => {
    setShowPasswordModal(true);
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
  };

  const handleChangePassword = async (currentPassword: string, newPassword: string) => {
    try {
      await userService.changePassword(user.account_id, newPassword, currentPassword);
      // Success handled in modal
    } catch (error: any) {
      throw new Error(error.message || 'Erro ao alterar senha');
    }
  };

  const getRoleName = (role: string) => {
    switch (role) {
      case 'admin':
        return 'Administrador';
      case 'manager':
        return 'Gerente';
      case 'user':
        return 'Usuário';
      default:
        return role;
    }
  };

  return (
    <>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>
                <i className="fas fa-user-circle"></i> Meu Perfil
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-info-circle"></i> Informações do Usuário
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="form-group">
                      <label>Nome</label>
                      <input
                        type="text"
                        className="form-control"
                        value={user.name || user.email}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label>E-mail</label>
                      <input
                        type="email"
                        className="form-control"
                        value={user.email}
                        disabled
                      />
                    </div>
                    <div className="form-group">
                      <label>Perfil</label>
                      <input
                        type="text"
                        className="form-control"
                        value={getRoleName(user.role || 'user')}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card card-warning card-outline">
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-key"></i> Segurança
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="text-muted">
                      Mantenha sua conta segura alterando sua senha regularmente.
                    </p>
                    <button
                      className="btn btn-warning btn-block"
                      onClick={handleOpenPasswordModal}
                    >
                      <i className="fas fa-key"></i> Alterar Senha
                    </button>
                  </div>
                </div>

                <div className="card card-info card-outline">
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-lightbulb"></i> Dicas de Segurança
                    </h3>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success"></i> Use uma senha forte com pelo menos 6 caracteres
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success"></i> Não compartilhe sua senha com ninguém
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success"></i> Altere sua senha periodicamente
                      </li>
                      <li>
                        <i className="fas fa-check-circle text-success"></i> Não use a mesma senha em outros sites
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ChangePasswordModal
          show={showPasswordModal}
          onClose={handleClosePasswordModal}
          onSubmit={handleChangePassword}
          userName={user.name || user.email}
        />
      </>
  );
};

export default Profile;
